import { BaseQueryFn, MutationDefinition } from "@reduxjs/toolkit/dist/query";
import { MutationTrigger } from "@reduxjs/toolkit/dist/query/react/buildHooks";
import { useAppDispatch } from "./store";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { showNotification } from "../store/reducers";
import { IMessageResponse } from "../shared";

type IHandleDeactivate<
  ApiName extends string,
  TResponse = IMessageResponse,
> = MutationTrigger<
  MutationDefinition<
    string,
    BaseQueryFn<
      {
        url: string;
        method: string | undefined;
        data?: any;
        params?: any;
      },
      unknown,
      unknown
    >,
    ApiName,
    TResponse,
    ApiName
  >
>;
export const useHandleDeactivate = <
  ApiName extends string,
  TResponse = IMessageResponse,
>(
  handleDeactivate: IHandleDeactivate<ApiName, TResponse>,
) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isDeactivateConfirmOpen, setIsDeactivateConfirmOpen] = useState(false);
  const [id, setId] = useState<string>("");

  const handleConfirmDeactivate = async () => {
    try {
      await handleDeactivate(id).unwrap();
      setIsDeactivateConfirmOpen(false);
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.successfulDeactivation"),
        }),
      );
    } catch (error: any) {
      dispatch(
        showNotification({
          type: "error",
          message: t("alert.somethingWentWrong"),
        }),
      );
    }
  };

  const handleCancelDeactivate = () => {
    setIsDeactivateConfirmOpen(false);
  };

  const onDeactivate = useCallback((id: string) => {
    setId(id);
    setIsDeactivateConfirmOpen(true);
  }, []);

  return {
    isDeactivateConfirmOpen,
    handleConfirmDeactivate,
    handleCancelDeactivate,
    onDeactivate,
  };
};
